export const slbCloudSolutionsPdp = {
  form: {
    chooseYourProfile: '1. Choose your profile:',
    enterYourUsers: '2. Enter your {{ plan }} users:',
    chooseYourContractTerms: '3. Choose your contract terms:',
    flexAmount: 'Avg. days / month:',
    BASETHREEYEAR: '3-years',
    BASEONEYEAR: '1-year',
    BASEONDEMAND: 'On Demand',
    PLUSTHREEYEAR: '3-years',
    PLUSONEYEAR: '1-year',
    PLUSONDEMAND: 'On Demand',
    BASEFLEX: 'Flex',
    PLUSFLEX: 'Flex',
  },
  product: {
    PTS: 'Delfi Domain Profiles',
    ODRS: 'On-Demand Reservoir Simulation',
    DRILLPLAN: "Delfi Applications",
    showPlans: 'Show plans comparison',
    hidePlans: 'Hide plans comparison',
    features: 'Features',
    poweredBy: 'Powered by {{company}}'
  },
  card: {
    users: 'Users',
    startingAt: 'Starting at',
    contractTerm: 'Contract term',
    flexDay: 'Flex ({{day}} day)',
    flexDays: 'Flex ({{day}} days)',
    addToCart: 'Add To Cart',
    contactUs: "Contact us to see the pricing",
    userPerMonth: '{{price}} user / month',
    addToBasket: "Add to basket"
  }
};
